import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { clearAPIError } from '../../reduxes/slices/api_errors/actions'
import { makeGetApiError } from '../../reduxes/slices/api_errors/selectors'
import { useSelectorDelegateStore } from '../../reduxes/stores/root_store/hooks'
import { ErrorMessage } from './error_message'

type Props = {
  httpMethod: string
  route: string
  uniqueKey?: string | number
  timeout?: number | null
  element?: any
  rootStore?: boolean
}

// eslint-disable-next-line
// @ts-ignore
export const ApiErrorMessage = ({
  httpMethod,
  route,
  uniqueKey,
  element,
  timeout = 3000,
  rootStore = false,
  ...props
}: Props & React.HTMLAttributes<HTMLDivElement>) => {
  const dispatch = useDispatch()
  const getApiError = useMemo(makeGetApiError, [])
  const errorFromSubStore: any = useSelector((state) =>
    // eslint-disable-next-line
    // @ts-ignore
    getApiError(state, { httpMethod, route, key: uniqueKey }),
  )
  const errorFromRootStore: any = useSelectorDelegateStore((state) =>
    // eslint-disable-next-line
    // @ts-ignore
    getApiError(state, { httpMethod, route, key: uniqueKey }),
  )
  const error = rootStore ? errorFromRootStore : errorFromSubStore

  useEffect(() => {
    if (error && timeout) {
      const timer = setTimeout(() => {
        dispatch(clearAPIError({ httpMethod, route, key: uniqueKey }))
      }, timeout)

      return () => {
        clearTimeout(timer)
      }
    }
  }, [dispatch, error, httpMethod, route, timeout, uniqueKey])

  const { error_message: message, validation_errors: validationErrors } =
    typeof error === 'string'
      ? { error_message: error, validation_errors: {} }
      : error || {}

  if (!error) {
    return null
  }

  const validationErrorKeys = Object.keys(validationErrors || {})

  return (
    <ErrorMessage element={element} {...props}>
      {message}
      {!!validationErrorKeys.length && (
        <ul>
          {validationErrorKeys.map((attribute) => {
            return <li key={attribute}>{validationErrors[attribute]}</li>
          })}
        </ul>
      )}
    </ErrorMessage>
  )
}
